'use client';

import { squadUpState } from './layouts/SquadUp';

interface TicketPackageButtonProps {
  url?: string;
  title?: string;
  target?: string;
}

export function TicketPackageButton({
  url,
  title,
  target = '_self',
}: TicketPackageButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!url) return;

    if (url.includes('squadup.com')) {
      e.preventDefault();
      const parts = url.split('/');
      const id = parts[parts.length - 1];
      squadUpState.eventId = id;
    }
  };

  return (
    <a
      className="top-auto mx-auto flex w-auto max-w-[305px] items-center justify-center gap-6 rounded bg-[--theme-primary] p-6 font-roboto text-lg font-medium uppercase tracking-[.17em] max-lg:mt-4"
      href={url}
      onClick={handleClick}
      data-klaviyo-form={
        url?.includes('klaviyo') ? url.split('klaviyo-form-')[1] : undefined
      }
      target={target}
    >
      {title}
    </a>
  );
}
